import locale from 'localization';

export const customerAccountColumns = [
  { key: 'customerAccountNumber', text: 'Account Number', width: '15%' },
  { key: 'cifNumber', text: 'MIF Number', width: '15%' },
  { key: 'name', text: 'Name', width: '15%' },
  { key: 'product', text: 'Product', width: '15%' },
  { key: 'balance', text: 'Balance', width: '15%' },
  { key: 'status', text: locale.status, width: '15%' },
  { key: 'options', text: '', width: '5%' }
];
